import { CarData, CarViewSettings } from 'features/car/types'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { Card } from 'ui/card/components'
import { Cell, CellSize, Row } from 'ui/grid'

import { useListSmartContractAPI } from '../../features/smart-contract/list/useListSmartContractAPI'

export type Props = {
  showSkeletons?: boolean
  skeletons?: React.ReactElement[]
  cars: CarData[] | null
  emptyText?: string
  cardSize: CellSize
  useSmartContract: boolean
  carViewSettings: CarViewSettings
  openCardsLinksInNewTab?: boolean
  showCreditPrice?: boolean
  showVideoIcon?: boolean
}

export const CarCardsList: FC<Props> = ({
  showSkeletons = false,
  skeletons,
  cars,
  emptyText,
  cardSize,
  carViewSettings,
  useSmartContract = false,
  openCardsLinksInNewTab = false,
  showCreditPrice = false,
  showVideoIcon
}) => {
  const { state, api } = useListSmartContractAPI()

  const prices = useMemo(() => {
    if (state && useSmartContract) {
      return state.cars.reduce((cars, car) => {
        return {
          ...cars,
          [car.carData.cardId]: {
            price: car.carData.price && car.carData.price > 0 ? car.carData.price : null,
            finalPrice: car.finalPrice && car.finalPrice > 0 ? car.finalPrice : null
          }
        }
      }, {} as Record<string, { price: number | null; finalPrice: number | null }>)
    }
    return {}
  }, [state])

  return (
    <Row>
      {showSkeletons && skeletons}
      {cars &&
        cars.map((car, i) => (
          <Cell {...cardSize} key={car.id} gutters={true}>
            <Card
              linkTarget={openCardsLinksInNewTab ? '_blank' : '_self'}
              smartContractEnabled={useSmartContract}
              carData={{
                ...car,
                price: useSmartContract ? prices[car.id]?.price : car.price,
                priceWithDiscounts:
                  useSmartContract && state?.tradeIn.behaviour !== 'enabled_without_calculations'
                    ? prices[car.id]?.finalPrice
                    : car.priceWithDiscounts
              }}
              carViewSettings={carViewSettings}
              showCreditPrice={showCreditPrice}
              showVideoIcon={car.has_video && showVideoIcon}
              onClick={(evt) => {
                const node = evt.target.closest('[data-tip')
                if (!node) return
                evt.preventDefault()
              }}
            />
          </Cell>
        ))}

      {emptyText && cars && !cars.length && (
        <Cell size={12}>
          <EmptyText>{emptyText}</EmptyText>
        </Cell>
      )}
    </Row>
  )
}

const EmptyText = styled.div`
  margin-top: ${({ theme }) => theme.spacing[4]};
  text-align: center;
  color: ${({ theme }) => theme.palette.grey[900]};
  ${({ theme }) => theme.textStyles.p1};
`
